import React, {useEffect} from 'react';
import {CollegeCardProps, generateUrlWithEvents} from 'src/components/CollegeCard';
import Card from '../Cards/Card';
import ContextualDataText from 'shared/components/college-card/contextual-data-text';
import {
  formatCollegeNameForCard,
  showTermNotOfferedModal,
} from 'shared/components/college-card/utils';
import ScholarshipBadge from 'src/components/CollegeSearch/scholarship-badge';
import {RecommendedCollege} from 'src/services/RecommendationsService';
import {earning} from 'shared/utils';
import FollowButton from 'shared/components/follow-button';
import {Link} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {isNil} from 'lodash';
import {Track} from 'src/utils/analytics';
import {Store} from 'src/types/store';
import styles from './styles.module.scss';
import {useMediaQuery} from '../../hooks/useMediaQuery';

function canEarnFromCollege(userType: string, college: RecommendedCollege): boolean {
  return userType === 'Student'
    ? earning(college.earningRelationship.statusType)
    : college.earningsPossible;
}

type HorizontalCollegeCardProps = Omit<
  CollegeCardProps,
  'showApplicationStatusMenu' | 'collegeApplicationStatus' | 'setApplicationStatus'
> & {
  className?: string;
};

export default function HorizontalCollegeCard(props: HorizontalCollegeCardProps) {
  const college = props.college;
  const campaignId = college.campaignId;
  const baseProps = props.baseProps || {};
  const studentId = useSelector<Store, string>((state) => state.student._id);
  const mq = useMediaQuery();

  useEffect(() => {
    !isNil(campaignId) &&
      Track.targetMeCampaignViewed(studentId, campaignId, 'sponsored-recommendation');
  }, [campaignId]);

  const collegeName: string = formatCollegeNameForCard(
    college.name,
    baseProps.showDeadline || false,
    college.earningRelationship
  );

  function handleFollowClick(event): void {
    event.preventDefault();
    if (college.isFollowing) {
      props.unfollowCollege(college._id);

      if (baseProps.openTermNotOfferedModal && showTermNotOfferedModal(college)) {
        baseProps.openTermNotOfferedModal(college._id);
      }
    } else {
      props.followCollege(college._id);
    }
  }

  return (
    <Link
      className={props.className}
      to={generateUrlWithEvents(
        college.slug,
        props.events.bucketEventId,
        props.events.recommendationsShownId
      )}
      data-testid="horizontal-college-card"
    >
      <Card className={styles.card}>
        <img className={styles.logo} alt={collegeName} src={props.college.logoUrl} />
        <div className={styles.textContainer}>
          <ContextualDataText college={props.college} bucketID={props.recommendationId} />
          <div className={styles.text}>
            {collegeName}
            {baseProps.showBadge && canEarnFromCollege('Student', props.college) && (
              <ScholarshipBadge className={styles.badge} />
            )}
          </div>
          <div className={styles.caption}>
            {props.college.city}, {props.college.state}
          </div>
        </div>
        <div className={styles.followButton}>
          <FollowButton
            collegeName={collegeName}
            following={props.college.isFollowing}
            outline
            onClick={handleFollowClick}
            compact={mq.MS_AND_DOWN}
          />
        </div>
      </Card>
    </Link>
  );
}
